import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';
export const SEND_MESSAGE_RESET = 'SEND_MESSAGE_RESET';

export const sendMessage = (params) => {
	return {
		type: SEND_MESSAGE,
		params,
	};
};

export const sendMessageSuccess = (response) => {
	return {
		type: SEND_MESSAGE_SUCCESS,
		response,
	};
};

export const sendMessageFail = (response) => {
	return {
		type: SEND_MESSAGE_FAIL,
		response,
	};
};

export const sendMessageReset = () => {
	return {
		type: SEND_MESSAGE_RESET,
	};
};

export const sendMessageApi = (data) => {
	return (dispatch) => {
		dispatch(sendMessage());
		axios
			.post(`${config.api.base_url}/voice-assistance/message`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const messageData = response.data;
				dispatch(sendMessageSuccess(messageData));
			})
			.catch((error) => {
				const errorMsg = error.response
					? error.response.data
					: error.message;
				dispatch(sendMessageFail(errorMsg));
			});
	};
};
